import _ from 'lodash';
import { Form } from 'antd';
import React from 'react';
import { Filters, FiltersProps } from 'src/modules/form/field/filters/Filters/Filters';
import { FiltersCollection } from 'src/modules/form/field/filters/types';
import { FormInstance } from 'antd/lib/form/hooks/useForm';

export interface FormFiltersProps extends Omit<FiltersProps, 'form'> {
  className?: string;
  onChange: (filterValues: FiltersCollection) => void;
  resultsCountKey: string;
  initialValues?: FiltersCollection;
  form: FormInstance;
}

export const FormFilters = ({
  className,
  filters,
  resultsCountKey,
  resultsCount,
  initialValues = {},
  onChange,
  form,
}: FormFiltersProps) => {
  return (
    <Form
      form={form}
      onFinish={_.debounce<any>(onChange, 500)}
      initialValues={{
        ...Object.entries(filters).reduce(
          // create a [filterFormName]: [] object with empty initial values
          (iv, [filterFormName]) => ({
            ...iv,
            [filterFormName]: [],
          }),
          {}
        ),
        ...initialValues,
      }}>
      <Filters
        className={className}
        resultsCountKey={resultsCountKey}
        resultsCount={resultsCount}
        form={form}
        filters={filters}
      />
    </Form>
  );
};
